// extracted by mini-css-extract-plugin
export var errorsContainer = "_s9-1";
export var link = "_s9-0";